import React from "react";
import NumberFormat from "react-number-format";

const CurrencyFormatter = ({onChange, inputRef, ...props}) => {
    return (
        <NumberFormat
            {...props}
            onValueChange={values => {
                onChange({
                    target: {
                        name: props.name,
                        value: values.value
                    }
                });
            }}
            thousandSeparator
            prefix={"$ "}
        />
    );
}

export default CurrencyFormatter;